import React, { useState, useEffect } from "react";
import "./Reset.css";
import { mainBg } from "../../assets/img/imgIndex";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { toast } from "react-toastify";

const ReserPass = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search || "");
  const email = queryParams.get("email") || "";
  const token = queryParams.get("token") || "";
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    console.log("Extracted Email:", email);
    console.log("Extracted Token:", token);
  }, [email, token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value || "",
    }));

    // Clear error when user starts typing
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      password: "",
      confirmPassword: "",
    };

    // Validate password
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }

    // Validate confirm password
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);

    // If no errors, submit the form
    if (!newErrors.password && !newErrors.confirmPassword) {
      try {
        setLoading(true);
        let payload = {
          email: email,
          token: token,
          new_password: formData.password,
        };
        let res = await post(URLS.RESET_PASSWORD, payload);
        console.log("Reset response:", res);

        if (res?.status === "success") {
          toast.success(res?.message || "Password reset successfully");
          setTimeout(() => {
            navigate("/");
          }, 1500);
        } else {
          toast.error(res?.message || "Failed to reset password");
        }
      } catch (error) {
        console.error("Reset password error:", error);
        toast.error(error?.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="reset-container">
      <div className="reset-left">
        <img src={mainBg} alt="Cooking" className="reset-left-img" />
      </div>
      <div className="reset-right">
        <form className="reset-form-wrapper" onSubmit={handleSubmit}>
          <h1 className="brand-name">Reset Password</h1>

          <div className="form-group">
            <label>Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password || ""}
                onChange={handleChange}
                placeholder="***************"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
            {errors.password && (
              <span className="error-message">{errors.password}</span>
            )}
          </div>
          <div className="form-group">
            <label>Confirm Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword1 ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword || ""}
                onChange={handleChange}
                placeholder="***************"
              />
              <span
                className="password-toggle"
                onClick={() => setShowPassword1(!showPassword1)}
              >
                {showPassword1 ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
            {errors.confirmPassword && (
              <span className="error-message">{errors.confirmPassword}</span>
            )}
          </div>

          <button type="submit" className="reset-button" disabled={loading}>
            {loading ? "Loading..." : "Reset"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReserPass;
